import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./store";
import i18n from "./i18n";
import ConfigContextProvider from "./contexts/configContext/ConfigContextProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HashRouter>
    <ConfigContextProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </ConfigContextProvider>
  </HashRouter>
);
